import React, { useState } from 'react'
import decodeHtml from '../functions/decodeHtml'
import Translation from '../General/Translation'

const Actors = ({actors, translation}) => {
    if(!actors[0]) {
        return ''
    }

    const [moreActorsOpen, toggleActors] = useState(false) 
    // need to put in Redux!
    const maxActors = pmkinoFrontVars.cinemaData.front.max_actors ? pmkinoFrontVars.cinemaData.front.max_actors === '-1' ? null : pmkinoFrontVars.cinemaData.front.max_actors : null

    const filteredActors = _.filter(actors, actor => {
        return actor.imageURL && actor.imageURL !== ''
    })

    const shorterActorsArr = maxActors && maxActors < filteredActors.length ? filteredActors.slice(0, (maxActors)) : null

    const actorItems = (filteredActors) => filteredActors.map(function(actor, index){
        if(actor.imageURL && actor.imageURL !== '') {
            const backgroundUrl = actor.imageURL;
            const styles = {
                    backgroundImage: `url(${backgroundUrl})`
                }
            
            return (
                <div key={index} className={'actor-wrapper'}>
                    <div className={'actor-image-wrapper'}>
                        <div className={'actor-image theme-radius-posters-top'}  style={styles}/>
                    </div>
                    <div className={'actor-names theme-radius-posters-bottom'}>
                        {actor.name && <p className={'text-medium'}>{decodeHtml(actor.name)}</p>}
                        {actor.character && <p className={'text-light typo-color-muted'}>{decodeHtml(actor.character)}</p>}
                    </div>
                </div>
            )
        }
    })
    
    return (
        <div className={'actors'}>
            <h2 className={'title-large'}><Translation id="actors" trans={translation}>Schauspieler</Translation></h2>
            {shorterActorsArr && shorterActorsArr.length !== 0 ? (
                <div className={'actors-wrapper'}>
                    {moreActorsOpen ? actorItems(filteredActors) : actorItems(shorterActorsArr)}
                </div>
            ) : (
                <div className={'actors-wrapper'}>
                    {actorItems(filteredActors)}
                </div>
            )}
            {shorterActorsArr && shorterActorsArr.length !== 0 ? (
                moreActorsOpen ? (
                    <button className={'text-light cursor-pointer button'} onClick={() => toggleActors(!moreActorsOpen)}> <Translation id="showLessButton" trans={translation}>weniger</Translation></button>
                ) : (
                    <button className={'text-light cursor-pointer button'} onClick={() => toggleActors(!moreActorsOpen)}><Translation id="showMoreButton" trans={translation}>mehr</Translation></button>)
            ) : ('')}
        </div>    
    )

}


export default Actors

